module.exports = __webpack_public_path__ + "static/pigly04-b14e17d1b24079850f3d1f15878efb04.png";